import { render } from "./LabsModule.vue?vue&type=template&id=11eaf475&scoped=true"
import script from "./LabsModule.vue?vue&type=script&lang=js"
export * from "./LabsModule.vue?vue&type=script&lang=js"

import "./LabsModule.vue?vue&type=style&index=0&id=11eaf475&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11eaf475"

export default script